import * as actions from 'app/actions/transport';
import http from 'app/services/http';
import { AUTOCOLON_ADD_ITEM, AUTOCOLON_DELETE_ITEM, AUTOCOLON_SEARCH_VALUE, AUTOCOLON_SELECT_ITEM, AUTOCOLON_SET_ITEM, AUTOCOLONS_SET_ITEMS, DIVISION_ADD_ITEM, DIVISION_DELETE_ITEM, DIVISION_SET_ITEM, DIVISION_SET_ITEMS, GEOFENSE_SET_SEARCH_VALUE } from 'app/utils/constants';
import { batch } from 'react-redux';

export const transportReducer = (
    state = {
        items: [],
        checkedItems: [],
        canGenerationItems: [],
        selectedItem: null,
        sortSelectedItem: { name: config.transportColumns[0].name, order: config.transportColumns[0].order },
        searchValue: '',
        typeItems: [],
        modelItems: [],
        groupItems: [],
        groupTypeItems: [],
        groupSelectedItem: null,
        groupSearchValue: '',
        checkListSelectedItem: null,
        inspectionSelectedItem: null,
        autocolonItems: [],
        divisionItems: [],
        autocolonSelectedItem: null,
        autocolonSearchValue: '',
        geofenceSearchValue: '',
    },
    action
) => {
    switch (action.type) {
        case GEOFENSE_SET_SEARCH_VALUE: {
            const { value } = action.payload;
            return {
                ...state,
                geofenceSearchValue: value,
            };
        }
        case AUTOCOLON_DELETE_ITEM: {
            const { id } = action.payload;
            return {
                ...state,
                autocolonItems: state.autocolonItems.filter((item) => item.id !== id),
            };
        }
        case DIVISION_DELETE_ITEM: {
            const { id } = action.payload;
            return {
                ...state,
                divisionItems: state.divisionItems.filter((item) => item.id !== id),
            };
        }
        case AUTOCOLON_ADD_ITEM: {
            const { data } = action.payload;
            return {
                ...state,
                autocolonItems: [...state.autocolonItems, data],
            };
        }
        case DIVISION_ADD_ITEM: {
            const { data } = action.payload;
            return {
                ...state,
                divisionItems: [...state.divisionItems, data],
            };
        }
        case AUTOCOLON_SET_ITEM: {
            const { item } = action.payload;
            let index = state.autocolonItems.findIndex((autocolonItem) => autocolonItem.id === item.id);
            const newAutocolonItems = [...state.autocolonItems];

            if (index !== -1) {
                newAutocolonItems.splice(index, 1, item);
            } else {
                newAutocolonItems.push(item);
            }
            return {
                ...state,
                autocolonItems: newAutocolonItems,
            };
        }
        case DIVISION_SET_ITEM: {
            const { item } = action.payload;
            let index = state.divisionItems.findIndex((divisionItem) => divisionItem.id === item.id);
            const newDivisionItems = [...state.divisionItems];
            if (index !== -1) {
                newDivisionItems.splice(index, 1, item);
            } else {
                newDivisionItems.push(item);
            }

            return {
                ...state,
                divisionItems: newDivisionItems,
            };
        }
        case AUTOCOLON_SELECT_ITEM: {
            const { value } = action.payload;
            return {
                ...state,
                autocolonSelectedItem: value,
            };
        }
        case AUTOCOLON_SEARCH_VALUE: {
            const { value } = action.payload;
            return {
                ...state,
                autocolonSearchValue: value,
            };
        }
        case 'TRANSPORT_SET_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                items: items,
            };
        }
        case 'TRANSPORT_ADD_CHECKED_ITEM': {
            const { id } = action.payload;

            return {
                ...state,
                checkedItems: [...state.checkedItems, id],
            };
        }
        case 'TRANSPORT_DELETE_CHECKED_ITEM': {
            const { id } = action.payload;

            return {
                ...state,
                checkedItems: state.checkedItems.filter((checkedId) => checkedId !== id),
            };
        }
        case 'TRANSPORT_SET_SELECTED_ITEM': {
            const { data } = action.payload;

            if (!data) {
                return {
                    ...state,
                    inspectionSelectedItem: null,
                    selectedItem: null,
                };
            }

            return {
                ...state,
                inspectionSelectedItem: null,
                selectedItem: {
                    ...data,
                    inspections: [],
                },
            };
        }
        case 'TRANSPORT_SET_SELECTED_ITEM_INSPECTION_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                selectedItem: {
                    ...state.selectedItem,
                    inspections: items,
                },
            };
        }
        case 'TRANSPORT_SET_INSPECTION_SELECTED_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                inspectionSelectedItem: data,
            };
        }
        case 'TRANSPORT_SET_SEARCH_VALUE': {
            const { value } = action.payload;

            return {
                ...state,
                searchValue: value,
            };
        }
        case 'TRANSPORT_SET_SORT_SELECTED_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                sortSelectedItem: {
                    name: data.name,
                    order: state.sortSelectedItem.name !== data.name ? data.order : state.sortSelectedItem.order === 'ASC' ? 'DESC' : 'ASC',
                },
            };
        }
        case 'TRANSPORT_ADD_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                items: [...state.items, data],
            };
        }
        case 'TRANSPORT_UPDATE_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                items: state.items.map((value) => {
                    if (value.id !== state.selectedItem.id) {
                        return value;
                    }

                    return {
                        ...state.selectedItem,
                        ...data,
                    };
                }),
                selectedItem: {
                    ...state.selectedItem,
                    ...data,
                },
            };
        }
        case 'TRANSPORT_DELETE_ITEM': {
            const { id } = action.payload;

            return {
                ...state,
                items: state.items.filter((item) => item.id !== id),
                selectedItem: null,
            };
        }
        case 'TRANSPORT_UPDATE_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                items: state.items.map((value) => items.find((item) => item.id === value.id) || value),
                checkedItems: [],
            };
        }
        case 'TRANSPORT_TYPE_SET_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                typeItems: items,
            };
        }
        case 'TRANSPORT_MODEL_SET_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                modelItems: items,
            };
        }
        case 'TRANSPORT_GROUP_SET_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                groupItems: items,
            };
        }
        case 'TRANSPORT_GROUP_SET_SELECTED_ITEM': {
            const { data } = action.payload;

            if (!data) {
                return {
                    ...state,
                    checkListSelectedItem: null,
                    groupSelectedItem: null,
                };
            }

            return {
                ...state,
                checkListSelectedItem: null,
                groupSelectedItem: {
                    ...data,
                    transports: [],
                    checklists: [],
                },
            };
        }
        case 'TRANSPORT_GROUP_SET_SELECTED_ITEM_TRANSPORT_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                groupSelectedItem: {
                    ...state.groupSelectedItem,
                    transports: items,
                },
            };
        }
        case 'TRANSPORT_GROUP_SET_SEARCH_VALUE': {
            const { value } = action.payload;

            return {
                ...state,
                groupSearchValue: value,
            };
        }
        case 'TRANSPORT_GROUP_ADD_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                groupItems: [...state.groupItems, data],
            };
        }
        case 'TRANSPORT_GROUP_UPDATE_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                groupItems: state.groupItems.map((item) => {
                    if (item.id !== data.id) {
                        return item;
                    }

                    return {
                        ...item,
                        ...data,
                    };
                }),
                groupSelectedItem: {
                    ...state.groupSelectedItem,
                    ...data,
                },
            };
        }
        case 'TRANSPORT_GROUP_DELETE_ITEM': {
            const { id } = action.payload;

            return {
                ...state,
                groupItems: state.groupItems.filter((item) => item.id !== id),
                groupSelectedItem: null,
            };
        }
        case 'TRANSPORT_SET_CAN_GENERATION_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                canGenerationItems: items,
            };
        }
        case 'TRANSPORT_GROUP_SET_TYPE_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                groupTypeItems: items,
            };
        }
        case 'TRANSPORT_GROUP_SET_CHECKLIST_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                groupSelectedItem: {
                    ...state.groupSelectedItem,
                    checklists: items,
                },
            };
        }
        case 'TRANSPORT_GROUP_SET_CHECKLIST_SELECTED_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                checkListSelectedItem: data,
            };
        }
        case 'TRANSPORT_GROUP_ADD_CHECK_LIST_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                groupSelectedItem: {
                    ...state.groupSelectedItem,
                    checklists: [data, ...state.groupSelectedItem.checklists],
                },
            };
        }
        case 'TRANSPORT_GROUP_UPDATE_CHECKLIST_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                groupSelectedItem: {
                    ...state.groupSelectedItem,
                    checklists: state.groupSelectedItem.checklists.map((item) => {
                        if (item.id !== data.id) {
                            return item;
                        }

                        return {
                            ...item,
                            ...data,
                        };
                    }),
                },
            };
        }
        case AUTOCOLONS_SET_ITEMS: {
            const { data } = action.payload;
            const id = state?.autocolonSelectedItem?.id;
            const item = data.find((autocolon) => autocolon.id === id);
            let autocolonSelectedItem = item && state.autocolonSelectedItem ? item : undefined;
            return {
                ...state,
                autocolonItems: data,
                autocolonSelectedItem,
            };
        }
        case DIVISION_SET_ITEMS: {
            const { data } = action.payload;

            return {
                ...state,
                divisionItems: data,
            };
        }
        default:
            return state;
    }
};

export function transportLoad() {
    return async function transportLoadThunk(dispatch) {
        const { data } = await http.get('/transport');
        return dispatch(actions.setItems(data));
    };
}

export function transportCreate(params) {
    return async function transportCreateThunk(dispatch) {
        const { data } = await http.post('/transport', params);
        return dispatch(actions.addItem(data));
    };
}

export function transportUpdate(id, params) {
    return async function transportUpdateThunk(dispatch) {
        const { data } = await http.put(`/transport/${id}`, params);
        return dispatch(actions.updateItem(data));
    };
}

export function transportDelete(id) {
    return async function transportDeleteThunk(dispatch) {
        await http.delete(`/transport/${id}`);
        return dispatch(actions.deleteItem(id));
    };
}

export function transportDataLoad(id) {
    return async function transportDataLoadThunk(dispatch) {
        const { data } = await http.get(`/transport/${id}/inspection`);
        return dispatch(actions.setInspectionItems(data));
    };
}

export function transportTypeLoad() {
    return async function transportTypeLoadThunk(dispatch) {
        const { data } = await http.get('/transport/type');
        return dispatch(actions.setTypeItems(data));
    };
}

export function transportModelLoad() {
    return async function transportModelLoadThunk(dispatch) {
        const { data } = await http.get('/transport/model');
        return dispatch(actions.setModelItems(data));
    };
}

export function transportGroupLoad() {
    return async function transportGroupLoadThunk(dispatch) {
        const { data } = await http.get('/transport/group');
        return dispatch(actions.setGroupItems(data));
    };
}

export function transportGroupDataLoad(id) {
    return async function transportGroupDataLoadThunk(dispatch) {
        const { data } = await http.get(`/transport/group/${id}`);
        return batch(() => {
            dispatch(actions.setGroupSelectedItemTransportItems(data.transports));
            dispatch(actions.setGroupCheckListItems(data.checklists));
        });
    };
}

export function transportGroupTransportSend(params) {
    return async function transportGroupTransportSendThunk(dispatch) {
        const { data } = await http.post('/transport/items/send', params);
        return dispatch(actions.updateItems(data));
    };
}

export function transportGroupCreate(params) {
    return async function transportCreateThunk(dispatch) {
        const { data } = await http.post('/transport/group', params);
        return dispatch(actions.addGroupItem(data));
    };
}

export function createDivisionAutocolon(params) {
    return async function transportCreateThunk(dispatch) {
        const { type, name, selectedAutocolons, id_division } = params;
        if (type === 'division') {
            const { data } = await http.post('/division', { name });
            dispatch(actions.addDivisionItem(data));
            if (selectedAutocolons.length) {
                for (let autocolon of selectedAutocolons) {
                    const res = await http.put(`/autocolon/${autocolon.id}`, autocolon);
                    dispatch(actions.setAutocolonItem(res.data));
                }
            }
            return;
        }
        const { data } = await http.post('/autocolon', {
            name,
            id_division,
        });
        return dispatch(actions.addAutocolonItem(data));
    };
}

export function updateDivisionAutocolon(params) {
    return async function transportCreateThunk(dispatch, getState) {
        const { type, name, selectedAutocolons, id_division, unselectedAutocolons, id } = params;
        const autocolons = getState().transport.autocolonItems.reduce((acc, val) => {
            acc[val.id] = val;
            return acc;
        }, {});
        if (type === 'division') {
            const { data } = await http.put(`/division/${id}`, { name });
            dispatch(actions.setDivisionItem(data));
            if (selectedAutocolons.length) {
                for (let autocolon of selectedAutocolons) {
                    const res = await http.put(`/autocolon/${autocolon.id}`, {
                        ...autocolons[autocolon.id],
                        name: autocolon.name,
                        id_division: data.id,
                    });
                    await dispatch(actions.setAutocolonItem(res.data));
                }
            }
            if (unselectedAutocolons.length) {
                for (let autocolon of unselectedAutocolons) {
                    const res = await http.put(`/autocolon/${autocolon.id}`, {
                        ...autocolons[autocolon.id],
                        name: autocolon.name,
                        id_division: null,
                    });
                    dispatch(actions.setAutocolonItem(res.data));
                }
            }
            return;
        }

        const { data } = await http.put(`/autocolon/${id}`, {
            ...autocolons[id],
            name,
            id_division,
        });
        return dispatch(actions.setAutocolonItem(data));
    };
}

export function updateAutocolonsList(list) {
    return async function transportCreateThunk() {
        await http.post(`/autocolon/list`, { list });
        await autocolunItemsLoad();
    };
}

export function deleteDivisionAutocolon(params) {
    return async function transportCreateThunk(dispatch) {
        const { type, id, selectedAutocolons } = params;
        if (type === 'division') {
            await http.delete(`/division/${id}`);
            dispatch(actions.deleteDivisionItem(id));
            if (selectedAutocolons.length) {
                for await (let autocolon of selectedAutocolons) {
                    const res = await http.put(`/autocolon/${autocolon.id}`, {
                        name: autocolon.name,
                        id_division: null,
                    });
                    dispatch(actions.setAutocolonItem(res.data));
                }
            }
            return;
        }
        await http.delete(`/autocolon/${id}`);
        return dispatch(actions.deleteAutocolonItem(id));
    };
}

export function transportGroupUpdate(id, params) {
    return async function transportUpdateThunk(dispatch) {
        const { data } = await http.put(`/transport/group/${id}`, params);
        return dispatch(actions.updateGroupItem(data));
    };
}

export function transportGroupDelete(id) {
    return async function transportDeleteThunk(dispatch) {
        await http.delete(`/transport/group/${id}`);
        return dispatch(actions.deleteGroupItem(id));
    };
}

export function transportItemGroupUpdate(params) {
    return async function transportItemGroupUpdateThunk(dispatch) {
        const { data } = await http.put('/transport/items/group', params);
        return dispatch(actions.updateItems(data));
    };
}

export function transportGroupTypeFormLoad() {
    return async function transportGroupTypeFormLoadThunk(dispatch) {
        const { data } = await http.get('/transport/group/type');
        return dispatch(actions.setGroupTypeItems(data));
    };
}

export function transportCanGenerationLoad() {
    return async function transportCanGenerationLoadThunk(dispatch) {
        const { data } = await http.get('/transport/can/generation');
        return dispatch(actions.setCanGenerationItems(data));
    };
}

export function transportGroupCheckListCreate(id, params) {
    return async function transportGroupCheckListCreateThunk(dispatch) {
        const { data } = await http.post(`/transport/group/${id}/checklist`, params);
        return dispatch(actions.addGroupSelectedItemCheckListItem(data));
    };
}

export function transportGroupCheckListUpdate(id, params) {
    return async function transportGroupCheckListUpdateThunk(dispatch) {
        const { data } = await http.put(`/transport/group/${id}/checklist/${params.id}`, { active: params.active });
        return dispatch(actions.updateGroupSelectedItemCheckListItem(data));
    };
}

export function autocolunItemsLoad() {
    return async function transportGroupLoadThunk(dispatch) {
        const { data } = await http.get('/autocolon');
        return dispatch(actions.setAutocolonItems(data));
    };
}

export function divisionItemsLoad() {
    return async function transportGroupLoadThunk(dispatch) {
        const { data } = await http.get('/division');
        return dispatch(actions.setDivisionItems(data));
    };
}

export default transportReducer;
